import React from 'react';

/** kaneai's ViewLogsIcon ("log lines + magnifier") — quoted from
 * apps/kaneai…/src/assets/images/ViewLogsIcon.tsx. 16×16, currentColor. */
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var ViewTestsIcon = function ViewTestsIcon() {
  return /*#__PURE__*/_jsxs("svg", {
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none",
    "aria-hidden": "true",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M2 3.5H11",
      stroke: "currentColor",
      strokeWidth: "1.25",
      strokeLinecap: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M2 6.5H9",
      stroke: "currentColor",
      strokeWidth: "1.25",
      strokeLinecap: "round"
    }), /*#__PURE__*/_jsx("path", {
      d: "M2 9.5H7",
      stroke: "currentColor",
      strokeWidth: "1.25",
      strokeLinecap: "round"
    }), /*#__PURE__*/_jsx("circle", {
      cx: "11.5",
      cy: "11",
      r: "2",
      stroke: "currentColor",
      strokeWidth: "1.25"
    }), /*#__PURE__*/_jsx("path", {
      d: "M13 12.5L14 13.5",
      stroke: "currentColor",
      strokeWidth: "1.25",
      strokeLinecap: "round"
    })]
  });
};